"use client";

import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";

export default function LoadingSpinner() {
  const router = useRouter();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleStart = () => setLoading(true);
    const handleStop = () => setLoading(false);

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleStop);
    router.events.on("routeChangeError", handleStop);

    handleStop();

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleStop);
      router.events.off("routeChangeError", handleStop);
    };
  }, [router]);

  return (
    <div
      className={`loader ${loading ? "opacity-100" : "opacity-0 pointer-events-none"}`}
    >
      <div className="loading">
        <div className="loading-inner" />
      </div>
    </div>
  );
}

